import './styles.scss';

import { MQTT_TOPIC } from '@constants/mqtt-topic';
import { UserTypeEnum } from '@enums/user-type.enum';
import { IHelpdesk } from '@interfaces/helpdesk';
import { IUser } from '@interfaces/user';
import { IResourceComponentsProps, useGetIdentity, useNavigation } from '@refinedev/core';
import { Col, Row } from 'antd';
import { HelpdeskListComponent } from 'pages/helpdesk/helpdesk-detail/ticket-list';
import React, { useEffect, useState } from 'react';

import { TicketMessageDetailComponent } from './ticket-message';

export const HelpdeskCrmDetail: React.FC<IResourceComponentsProps> = () => {
    const { data: userIdentity } = useGetIdentity<IUser.IUserIdentity>();
    const userType = userIdentity?.userType;
    const auth = JSON.parse(localStorage.getItem('auth') || '{}') || {};
    const currTenantId = auth?.tenantId;
    const [ticket, setTicket] = useState<IHelpdesk.Ticket>();
    const { push } = useNavigation();
    const [topic, setTopic] = useState<string>();

    useEffect(() => {
        if (userType === UserTypeEnum.TENANT) {
            setTopic(`${MQTT_TOPIC.TICKET}${currTenantId}`);
        }
        if (userType === UserTypeEnum.RESELLER) {
            setTopic(`${MQTT_TOPIC.TICKET}${currTenantId}`);
        }
        if (userType === UserTypeEnum.SYS_ADMIN) {
            setTopic(`${MQTT_TOPIC.TICKET}${currTenantId}`);
        }
    }, [userIdentity?.userType]);

    const handleClickTicket = (ticket: IHelpdesk.Ticket) => {
        setTicket(ticket);
        push(`/sale/helpdesk/show/${ticket?.id}?status=${ticket?.status}`);
    };

    return (
        <section className="edit-helpdesk-container w-full h-full">
            {topic && (
                <Row className="w-full h-full">
                    <Col xs={7} className="h-full edit-helpdesk-col">
                        <HelpdeskListComponent
                            topic={topic}
                            handleClickTicket={handleClickTicket}
                        />
                    </Col>
                    <Col xs={17} className="h-full edit-helpdesk-col content-col flex-col">
                        <TicketMessageDetailComponent ticket={ticket} />
                    </Col>
                </Row>
            )}
        </section>
    );
};
